import { render, staticRenderFns } from "./artigosinterna.vue?vue&type=template&id=7a40afdb&scoped=true"
import script from "./artigosinterna.vue?vue&type=script&lang=js"
export * from "./artigosinterna.vue?vue&type=script&lang=js"
import style0 from "./artigosinterna.vue?vue&type=style&index=0&id=7a40afdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a40afdb",
  null
  
)

export default component.exports